// extracted by mini-css-extract-plugin
export default {"productGallery":"iL-z","inQuickShop":"jL-z"};